export function valueExistsTS (v): boolean {
  return Boolean(v !== null && v !== undefined && v)
}
